import React from 'react';

import FooterContainer from 'containers/footer/FooterContainer';

export default () =>
    <div className="fullheight">
        <section className="boxes themeBG">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-10 p-30 p-b-60">
                        <h3>Seychelles</h3>
                        <p>
                            Seychelles Seychelles is calling you to come,
                            experience, indulge and be tantalized! This stunning
                            archipelago of tropical islands lying in the Indian
                            Ocean off the coast of Kenya is a honeymooners',
                            couples', or single vacationer’s dream. Seychelles
                            is the land of natural beauty, the ultimate place to
                            go for the pristine beaches, clean & clear blue
                            water, soft white sand, numerous and secluded
                            beaches, and a medley of exotic and inspiring
                            cultures and cuisine with a touch of Africa, China,
                            France, Britain, the Arab world and India, that
                            would surpass your expectations. Come and experience
                            this natural beauty at its best! Seychelles attracts
                            many celebrities, the likes of Prince William of
                            Great Britain, and many more! It is "THE PLACE" for
                            honeymooners or couples. It is also great for
                            families and visitors from all over the world who
                            love to bask in the tantalizing sun rays, surrounded
                            by stunning natural scenery, unique wildlife and a
                            beautiful diverse culture. What is Seychelles
                            Seychelles is a small islandic country in the Indian
                            ocean, off the African coast of Kenya. It is made up
                            of 115 islands of which only a few are habitable.
                            Each island is different and unique with its own
                            character and attractions. Surely, you can never get
                            bored! The islands were uninhabited until the late
                            18th century. The French traders and sailors were
                            first to arrive and to settle. With time there was
                            migration from Africa, Britain, China and the Arab
                            world. As such Seychelles today is a unique and
                            interesting cosmos of different cultures and
                            cuisine. Things to do ; 0. Chilling at gorgeous
                            beaches. Each is different and unique, let's just
                            give you a preview! The ‘Anse Source d’Argent beach
                            (in La Digue) This beach is gorgeous! It is dressed
                            with giant smooth granite boulders, dancing or
                            gentle swaying palm trees, soft white sand and
                            clear, pristine blue water. It easily passes as the
                            best beach in the world. It is every photographer's
                            ultimate dream. The photographs that come out of
                            this place, even from an amateur are beyond
                            exceptional. This makes it the best place to take
                            pictures for special occasions with special people
                            and for special memories!! La Digue has stunning
                            natural vegetation, wild animals and a great
                            diversity of bird including some rare species. One
                            of the amazing and unique aspects of this island is
                            that, bicycles and ox carts are the preferred modes
                            of transport, making it one of the green travel
                            destinations. Petite Anse beach This is a
                            horseshoe-shaped beach! What so special about this
                            beach is its calm waters and beautifully stunning
                            sunsets. Mahé, and Anse Royale beaches These present
                            secluded sheltered bays or inlets. This beach also
                            offers one of the best snorkeling area. How about a
                            Creole picnic in one of the coves before or after
                            snorkeling? Sounds like fun and exotic!! Mahe This
                            is the commercial hub of the 115 islands that make
                            up the country of Seychelles. This island is home to
                            the capital city called Victoria. Mahe boasts of
                            lush forests, spectacular mountain peaks and greater
                            than 60 beaches. There is plenty of beaches to
                            sample!! Anse Lazio beach on (Praslin Island) This
                            beach is famous for its crescent shape and soft
                            white sands. There is only one 18-hole championship
                            golf course in Seychelles. It is called Lemuria and
                            it is located on Praslin lsland. Snorkeling and deep
                            sea diving: Seychelles is the best place for scuba
                            diving and snorkeling! The weather is just perfect
                            for year-round diving. Seychelles has six marine
                            national parks, which are tropical, unique and
                            diverse. These offer an array of colorful and
                            dazzling corals and fish. There is plenty of
                            opportunity to see larger sea animals like hawksbill
                            turtles. There is a popular diving spot called Shark
                            Bank, here you can actually dive among stingrays and
                            puffer fish. The experience is unbelievable!! You
                            will have a great experience with Whitetip company.
                            This is a team of professional divers who are very
                            knowledgeable about the trade, both surface and
                            underwater. They know the best sites and hidden gems
                            for both snorkeling and diving. They are
                            laser-focused on your safety as well as providing an
                            unforgettable experience. This is simply the best
                            place in the world to see and experience ocean
                            diversity! Sailing What an awesome place to sail
                            while exploring these exotic islands. You can hire a
                            clipper, cataraman or yacht and go on an island
                            expedition, sailing, exploring, adventuring and best
                            of all, taking in the beauty that these islands
                            offer! There is magnificent coral atolls and sand
                            cays on the outer islands to satisfy that
                            adventurous appetite!
                        </p>
                    </div>
                </div>
            </div>
        </section>
        <FooterContainer />
    </div>;



// WEBPACK FOOTER //
// ./src/pages/gallery/seychelles/SeychellesGallery.jsx